import CreateEmployeeForm from "components/cms/CreateEmployeeForm"
import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import Typography from "components/ui/typography"
import { getCMSSegments } from "utils/helper"

const CreateEmployee = () => {
  const segments = getCMSSegments()

  return (
    <EmployeeDashboardWrapper>
      <DefBreadcrumb
        segments={segments}
        prefix="cms"
      />
      <Typography
        variant="subheading4"
        as="h1"
        className="text-primary"
      >
        Buat Admin Baru
      </Typography>

      <CreateEmployeeForm />
    </EmployeeDashboardWrapper>
  )
}

export default CreateEmployee
